<template>
  <div
    data-qa="contacts-item-messengers"
    class="d-inline-flex flex-wrap ga-2"
  >
    <div
      v-for="messenger in messengers"
      :key="messenger.id"
    >
      <a
        v-if="messenger.messenger_type === 'whatsapp'"
        :href="`https://wa.me/${messenger.username}`"
        class="whatsapp-button px-4 py-3 rounded text-decoration-none d-flex align-center"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/static/_v1/pd/icons/socials/whatsapp-white.svg"
          width="20"
          height="20"
          :alt="`${t('Иконка', options)} WhatsApp`"
          class="mr-2"
        >
        <span class="bg-gray-0--text text-button">
          WhatsApp
        </span>
      </a>
      <a
        v-else-if="messenger.messenger_type === 'telegram'"
        :href="`https://t.me/${messenger.username}`"
        class="tg-button px-4 py-3 rounded text-decoration-none d-flex align-center"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/static/_v1/pd/icons/socials/tg-white.svg"
          width="20"
          height="20"
          :alt="`${t('Иконка', options)} Telegram`"
          class="mr-2"
        >
        <span class="bg-gray-0--text text-button">
          Telegram
        </span>
      </a>
      <a
        v-else-if="messenger.messenger_type === 'max'"
        :href="`https://max.ru/${messenger.username}`"
        class="max-button px-4 py-3 rounded text-decoration-none d-flex align-center"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/static/_v1/pd/icons/socials/max-white.svg"
          width="20"
          height="20"
          :alt="`${t('Иконка', options)} Max`"
          class="mr-2"
        >
        <span class="bg-gray-0--text text-button">
          Max
        </span>
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/info/contacts/types'

defineProps<{
  messengers: ContextStore['context']['company_contacts'][number]['messengers']['all']
}>()

const { t, language } = I18NextVue
const options = { ns: language }
</script>

<style lang="scss" scoped>
.whatsapp-button {
  background-color: #2BB140;
}

.tg-button {
  background-color: #28A9E8;
}

.max-button {
  background-color: #545BEC;
}
</style>
